const highchartTranslations = {
  en: {
    "loading": "Loading...",
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "shortMonths": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "weekdays": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "decimalPoint": ".",
    "numericSymbols": [
      "k",
      "M",
      "G",
      "T",
      "P",
      "E"
    ],
    "resetZoom": "Reset zoom",
    "resetZoomTitle": "Reset zoom level 1:1",
    "thousandsSep": " ",
    "rangeSelectorZoom": "Zoom",
    "rangeSelectorFrom": "",
    "rangeSelectorTo": "→",
    "accessibility": {
      "defaultChartTitle": "Chart",
      "chartContainerLabel": "{title}. Highcharts interactive chart.",
      "svgContainerLabel": "Interactive chart",
      "drillUpButton": "{buttonText}",
      "credits": "Chart credits: {creditsStr}",
      "thousandsSep": ",",
      "svgContainerTitle": "",
      "graphicContainerLabel": "",
      "screenReaderSection": {
        "beforeRegionLabel": "",
        "afterRegionLabel": "",
        "annotations": {
          "heading": "Chart annotations summary",
          "descriptionSinglePoint": "{annotationText}. Related to {annotationPoint}",
          "descriptionMultiplePoints": "{annotationText}. Related to {annotationPoint}{ Also related to, #each(additionalAnnotationPoints)}",
          "descriptionNoPoints": "{annotationText}"
        },
        "endOfChartMarker": "End of interactive chart."
      },
      "sonification": {
        "playAsSoundButtonText": "Play as sound, {chartTitle}",
        "playAsSoundClickAnnouncement": "Play"
      },
      "legend": {
        "legendLabelNoTitle": "Toggle series visibility, {chartTitle}",
        "legendLabel": "Chart legend: {legendTitle}",
        "legendItem": "Show {itemName}"
      },
      "zoom": {
        "mapZoomIn": "Zoom chart",
        "mapZoomOut": "Zoom out chart",
        "resetZoomButton": "Reset zoom"
      },
      "rangeSelector": {
        "dropdownLabel": "{rangeTitle}",
        "minInputLabel": "Select start date.",
        "maxInputLabel": "Select end date.",
        "clickButtonAnnouncement": "Viewing {axisRangeDescription}"
      },
      "table": {
        "viewAsDataTableButtonText": "View as data table, {chartTitle}",
        "tableSummary": "Table representation of chart."
      },
      "announceNewData": {
        "newDataAnnounce": "Updated data for chart {chartTitle}",
        "newSeriesAnnounceSingle": "New data series: {seriesDesc}",
        "newPointAnnounceSingle": "New data point: {pointDesc}",
        "newSeriesAnnounceMultiple": "New data series in chart {chartTitle}: {seriesDesc}",
        "newPointAnnounceMultiple": "New data point in chart {chartTitle}: {pointDesc}"
      },
      "seriesTypeDescriptions": {
        "boxplot": "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.",
        "arearange": "Arearange charts are line charts displaying a range between a lower and higher value for each point.",
        "areasplinerange": "These charts are line charts displaying a range between a lower and higher value for each point.",
        "bubble": "Bubble charts are scatter charts where each data point also has a size value.",
        "columnrange": "Columnrange charts are column charts displaying a range between a lower and higher value for each point.",
        "errorbar": "Errorbar series are used to display the variability of the data.",
        "funnel": "Funnel charts are used to display reduction of data in stages.",
        "pyramid": "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.",
        "waterfall": "A waterfall chart is a column chart where each column contributes towards a total end value."
      },
      "chartTypes": {
        "emptyChart": "Empty chart",
        "mapTypeDescription": "Map of {mapTitle} with {numSeries} data series.",
        "unknownMap": "Map of unspecified region with {numSeries} data series.",
        "combinationChart": "Combination chart with {numSeries} data series.",
        "defaultSingle": "Chart with {numPoints} data {#plural(numPoints, points, point)}.",
        "defaultMultiple": "Chart with {numSeries} data series.",
        "splineSingle": "Line chart with {numPoints} data {#plural(numPoints, points, point)}.",
        "splineMultiple": "Line chart with {numSeries} lines.",
        "lineSingle": "Line chart with {numPoints} data {#plural(numPoints, points, point)}.",
        "lineMultiple": "Line chart with {numSeries} lines.",
        "columnSingle": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
        "columnMultiple": "Bar chart with {numSeries} data series.",
        "barSingle": "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
        "barMultiple": "Bar chart with {numSeries} data series.",
        "pieSingle": "Pie chart with {numPoints} {#plural(numPoints, slices, slice)}.",
        "pieMultiple": "Pie chart with {numSeries} pies.",
        "scatterSingle": "Scatter chart with {numPoints} {#plural(numPoints, points, point)}.",
        "scatterMultiple": "Scatter chart with {numSeries} data series.",
        "boxplotSingle": "Boxplot with {numPoints} {#plural(numPoints, boxes, box)}.",
        "boxplotMultiple": "Boxplot with {numSeries} data series.",
        "bubbleSingle": "Bubble chart with {numPoints} {#plural(numPoints, bubbles, bubble)}.",
        "bubbleMultiple": "Bubble chart with {numSeries} data series."
      },
      "axis": {
        "xAxisDescriptionSingular": "The chart has 1 X axis displaying {names[0]}. {ranges[0]}",
        "xAxisDescriptionPlural": "The chart has {numAxes} X axes displaying {#each(names, -1) }and {names[-1]}.",
        "yAxisDescriptionSingular": "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}",
        "yAxisDescriptionPlural": "The chart has {numAxes} Y axes displaying {#each(names, -1) }and {names[-1]}.",
        "timeRangeDays": "Data range: {range} days.",
        "timeRangeHours": "Data range: {range} hours.",
        "timeRangeMinutes": "Data range: {range} minutes.",
        "timeRangeSeconds": "Data range: {range} seconds.",
        "rangeFromTo": "Data ranges from {rangeFrom} to {rangeTo}.",
        "rangeCategories": "Data range: {numCategories} categories."
      },
      "exporting": {
        "chartMenuLabel": "Chart menu",
        "menuButtonLabel": "View chart menu, {chartTitle}"
      },
      "series": {
        "summary": {
          "default": "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "defaultCombination": "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "line": "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "lineCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "spline": "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "splineCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "column": "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bars, bar)}.",
          "columnCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#plural(series.points.length, bars, bar)}.",
          "bar": "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bars, bar)}.",
          "barCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#plural(series.points.length, bars, bar)}.",
          "pie": "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, slices, slice)}.",
          "pieCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#plural(series.points.length, slices, slice)}.",
          "scatter": "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, points, point)}.",
          "scatterCombination": "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#plural(series.points.length, points, point)}.",
          "boxplot": "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, boxes, box)}.",
          "boxplotCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#plural(series.points.length, boxes, box)}.",
          "bubble": "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.",
          "bubbleCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.",
          "map": "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, areas, area)}.",
          "mapCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#plural(series.points.length, areas, area)}.",
          "mapline": "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "maplineCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.",
          "mapbubble": "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.",
          "mapbubbleCombination": "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#plural(series.points.length, bubbles, bubble)}."
        },
        "description": "{description}",
        "xAxisDescription": "X axis, {name}",
        "yAxisDescription": "Y axis, {name}",
        "nullPointValue": "No value",
        "pointAnnotationsDescription": "{Annotation: #each(annotations). }"
      }
    }
  },
  fi: {
    loading: 'Ladataan...',
    months: ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'],
    weekdays: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
    shortMonths: ['Tammi', 'Helmi', 'Maalis', 'Huhti', 'Touko', 'Kesä', 'Heinä', 'Elo', 'Syys', 'Loka', 'Marras', 'Joulu'],
    shortWeekdays: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
    resetZoom: "Nollaa zoomaus",
    resetZoomTitle: "Nollaa zoomaus tasolle 1:1",
    thousandsSep: " ",
    rangeSelectorZoom: "Zoom",
    "numericSymbols": [
      "t",
      "M",
      "G",
      "T",
      "P",
      "E"
    ],
    "decimalPoint": ",",
  }
}

export default highchartTranslations;
